import React, { Fragment, useEffect, useState } from "react";
import { getDetectedBreach, getSavedBreach } from "../../../store/service";
import BreachExposureTable from "./BreachExposureTable";
import BreachBoxDescription from "./BreachBoxDescription";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import { breachServiceActive } from "../../../util/CommonBreach";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import BreachesTab from "../BreachesTab";
import BreachHeaderText from "../BreachHeaderText";

let defaultSortState = {
    organization: false,
    breachDate: false,
    breachRiskRating: false,
};

const MyBreachExposure = () => {
    const dispatch = useDispatch();
    const breachService = useSelector((state: ApplicationState) => (state.breachServiceState ? state.breachServiceState.breachService : null));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [detectedBreachDetailsList, setDetectedBreachDetailsList] = useState([]);
    const [sortName, setSortName] = useState("");
    const [savedBreachDetailsList, setSavedBreachDetailsList] = useState([]);
    const [detectedBreachLoading, setDetectedBreachLoading] = useState(true);
    const [savedBreachLoading, setSavedBreachLoading] = useState(true);
    const [sortState, setSortState] = useState<any>({
        detectedBreach: defaultSortState,
        savedBreach: defaultSortState,
    });
    const [isRemoveCall, setIsRemoveCall] = useState(false);
    const getSavedBreachList = () => {
        getSavedBreach()
            .then((res) => {
                setSavedBreachLoading(false);
                if (res.isSuccess) {
                    setSavedBreachDetailsList(res.savedBreachesList);
                }
            })
            .catch((err: any) => {
                setSavedBreachLoading(false);
            });
    };

    useEffect(() => {
        if (breachServiceActive(breachService)) {
            getDetectedBreach()
                .then((res) => {
                    setDetectedBreachLoading(false);
                    if (res.isSuccess) {
                        setDetectedBreachDetailsList(res.detectedBreachDetailsList);
                    }
                })
                .catch((err: any) => {
                    setDetectedBreachLoading(false);
                });
            getSavedBreachList();
        }
    }, []);

    const handleSaveBreachSort = (name: any, prevSort?: any) => {
        let { organization, breachDate, breachRiskRating } = sortState.savedBreach;
        setSortName(name);
        switch (name) {
            case "organization":
                if (prevSort === undefined ? organization : prevSort) {
                    savedBreachDetailsList.sort((a: any, b: any) => (a.organization > b.organization ? 1 : -1));
                } else {
                    savedBreachDetailsList.sort((a: any, b: any) => (b.organization > a.organization ? 1 : -1));
                }
                break;
            case "breachDate":
                if (prevSort === undefined ? breachDate : prevSort) {
                    savedBreachDetailsList.sort((a: any, b: any) => (new Date(a.breachDate) > new Date(b.breachDate) ? 1 : -1));
                } else {
                    savedBreachDetailsList.sort((a: any, b: any) => (new Date(b.breachDate) > new Date(a.breachDate) ? 1 : -1));
                }
                break;
            case "breachRiskRating":
                if (prevSort === undefined ? breachRiskRating : prevSort) {
                    savedBreachDetailsList.sort((a: any, b: any) => a.score - b.score);
                } else {
                    savedBreachDetailsList.sort((a: any, b: any) => b.score - a.score);
                }
                break;
            default:
                break;
        }
        setSavedBreachDetailsList(savedBreachDetailsList);
    };
    const handleDetectedBreachSort = (name: string) => {
        let { organization, breachDate, breachRiskRating } = sortState.detectedBreach;

        switch (name) {
            case "organization":
                if (organization) {
                    detectedBreachDetailsList.sort((a: any, b: any) => (a.organization > b.organization ? 1 : -1));
                } else {
                    detectedBreachDetailsList.sort((a: any, b: any) => (b.organization > a.organization ? 1 : -1));
                }
                break;
            case "breachDate":
                if (breachDate) {
                    detectedBreachDetailsList.sort((a: any, b: any) => (new Date(a.breachDate) > new Date(b.breachDate) ? 1 : -1));
                } else {
                    detectedBreachDetailsList.sort((a: any, b: any) => (new Date(b.breachDate) > new Date(a.breachDate) ? 1 : -1));
                }
                break;
            case "breachRiskRating":
                if (breachRiskRating) {
                    detectedBreachDetailsList.sort((a: any, b: any) => a.score - b.score);
                } else {
                    detectedBreachDetailsList.sort((a: any, b: any) => b.score - a.score);
                }
                break;
            default:
                break;
        }
        setSortState({
            ...sortState,
            detectedBreach: {
                ...sortState.detectedBreach,
                [name]: !sortState.detectedBreach[name],
            },
        });
        setDetectedBreachDetailsList(detectedBreachDetailsList);
    };

    useEffect(() => {
        if (sortName) {
            handleSaveBreachSort(sortName, !sortState.savedBreach[sortName]);
        }
        return () => {
            setSortName("");
            setIsRemoveCall(false);
        };
    }, [savedBreachDetailsList.length]);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <Fragment>
            <div className="row">
                <BreachHeaderText />
            </div>
            <BreachesTab selectedTab="2" />
            <div className="row" id="content">
                <div className="col-xs-12 col-sm-12">
                    <div className="box">
                        <div style={{ backgroundColor: "#fff" }}>
                            <div className="box" style={{ paddingBottom: "0px" }}>
                                <div className="box-header padding-left-5rem">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="breach-exposure" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="breach-section-title">My Breach Exposures</h2>
                                        </div>
                                    </div>
                                </div>
                                <BreachBoxDescription
                                    title="Detected Exposures"
                                    description="The list below includes data breaches we've detected to have exposed your personal information."
                                />
                                <div className="box-content">
                                    <BreachExposureTable
                                        detectedBreachData={detectedBreachDetailsList}
                                        savedBreachData={savedBreachDetailsList}
                                        handleDetectedBreachSort={handleDetectedBreachSort}
                                        isDetectedLoading={detectedBreachLoading}
                                        isSavedLoading={savedBreachLoading}
                                        handleSaveBreachSort={handleSaveBreachSort}
                                        getNewData={getSavedBreachList}
                                        sortState={sortState}
                                        setIsRemoveCall={setIsRemoveCall}
                                        isRemoveCall={isRemoveCall}
                                        setSortState={setSortState}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default MyBreachExposure;
